import type {
  AddLocationAddressType,
  AddLocationLocationType,
} from "@/Shared/Types/locationTypes";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { emptyLocationErrorMessages } from "./locationsEmptyErrorMessages";
import type { LocationErrors } from "./locationsErrorMessagesForLocation";
import { locationsErrorMessagesForLocation } from "./locationsErrorMessagesForLocation";

export function errorMessageForSameDeliveryAddress(
  pickupAddress: AddLocationAddressType,
  deliveryAddress: AddLocationAddressType,
): string | undefined {
  if (
    pickupAddress.postalCode &&
    pickupAddress.postalCode === deliveryAddress.postalCode &&
    pickupAddress.city === deliveryAddress.city &&
    pickupAddress.addressLine &&
    pickupAddress.addressLine === deliveryAddress.addressLine
  ) {
    return "Delivery address is identical to the pickup address";
  }

  return undefined;
}

export function locationsErrorMessagesForDeliveryLocation(
  pickupLocation: AddLocationLocationType,
  deliveryLocation: AddLocationLocationType,
): LocationErrors {
  const errorMessages = locationsErrorMessagesForLocation(
    deliveryLocation,
    false,
  );

  if (
    pickupLocation.locationType === LocationType.Residential &&
    deliveryLocation.locationType === LocationType.Residential
  ) {
    errorMessages.locationType =
      "FreightSimple does not support purely residential moves";
  }

  return errorMessages;
}

export function warningMessagesForDeliveryLocation(
  pickupLocation: AddLocationLocationType | undefined,
  deliveryLocation: AddLocationLocationType,
): LocationErrors {
  const errorMessages = emptyLocationErrorMessages();

  if (
    pickupLocation !== undefined &&
    pickupLocation.address.postalCode &&
    pickupLocation.address.postalCode === deliveryLocation.address.postalCode &&
    pickupLocation.address.city === deliveryLocation.address.city
  ) {
    errorMessages.address.postalCode =
      "⚠️ Delivery postal code and city match the pickup location";
  }

  if (
    deliveryLocation.locationType === LocationType.Residential &&
    !deliveryLocation.accessorials.includes("LOGISTICS_LIFT_GATE_REQUIRED")
  ) {
    return {
      ...errorMessages,
      locationType: "Typically residental deliveries require lift gates",
    };
  }

  if (
    deliveryLocation.locationType === LocationType.Residential &&
    !deliveryLocation.accessorials.includes("SCHEDULING_APPOINTMENT_REQUIRED")
  ) {
    return {
      ...errorMessages,
      locationType: "Typically residental deliveries require an appointment",
    };
  }

  return errorMessages;
}
